module.exports = __webpack_public_path__ + "img/耀皮.814094de.png";